import { c as _c } from "react/compiler-runtime";
import { useDate } from "@website/accommodation-ui/hotel-search";
import { DatepickerSelectedDateType } from "@website/ui/datepicker";
import { dateFormat } from "@website/utils/date-format";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
export const useCalendar = () => {
  const $ = _c(44);
  const router = useRouter();
  const {
    date_to,
    date_from
  } = router.query as Record<string, string>;
  let t0;
  if ($[0] !== date_from) {
    t0 = dateFormat(date_from, {
      locale: "fa",
      numberConvert: false,
      template: "yyyy"
    });
    $[0] = date_from;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = Number(t0);
  let t2;
  if ($[2] !== date_from) {
    t2 = dateFormat(date_from, {
      locale: "fa",
      numberConvert: false,
      template: "MM"
    });
    $[2] = date_from;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = Number(t2);
  let t4;
  if ($[4] !== date_from) {
    t4 = dateFormat(date_from, {
      locale: "fa",
      numberConvert: false,
      template: "dd"
    });
    $[4] = date_from;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = Number(t4);
  let t6;
  if ($[6] !== date_from) {
    t6 = toString(dateFormat(date_from, {
      locale: "en",
      template: "yyyy-MM-dd"
    }));
    $[6] = date_from;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t5 || $[11] !== t6) {
    t7 = {
      year: t1,
      month: t3,
      day: t5,
      dateTime: t6
    };
    $[8] = t1;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== date_to) {
    t8 = dateFormat(date_to, {
      locale: "fa",
      numberConvert: false,
      template: "yyyy"
    });
    $[13] = date_to;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = Number(t8);
  let t10;
  if ($[15] !== date_to) {
    t10 = dateFormat(date_to, {
      locale: "fa",
      numberConvert: false,
      template: "MM"
    });
    $[15] = date_to;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = Number(t10);
  let t12;
  if ($[17] !== date_to) {
    t12 = dateFormat(date_to, {
      locale: "fa",
      numberConvert: false,
      template: "dd"
    });
    $[17] = date_to;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = Number(t12);
  let t14;
  if ($[19] !== date_to) {
    t14 = toString(dateFormat(date_to, {
      locale: "en",
      template: "yyyy-MM-dd"
    }));
    $[19] = date_to;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t11 || $[22] !== t13 || $[23] !== t14 || $[24] !== t9) {
    t15 = {
      year: t9,
      month: t11,
      day: t13,
      dateTime: t14
    };
    $[21] = t11;
    $[22] = t13;
    $[23] = t14;
    $[24] = t9;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t15 || $[27] !== t7) {
    t16 = [t7, t15];
    $[26] = t15;
    $[27] = t7;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const datePickerInitialValues = t16;
  const {
    date,
    onChangeDate
  } = useDate(datePickerInitialValues);
  let t17;
  if ($[29] !== router) {
    t17 = updateObject => router.replace({
      pathname: router.pathname,
      query: deepOmit({
        ...router.query,
        ...updateObject
      }, isFilled)
    }, undefined, {
      scroll: false,
      shallow: true
    });
    $[29] = router;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  const setQueryParameters = t17;
  let t18;
  if ($[31] !== onChangeDate || $[32] !== setQueryParameters) {
    t18 = date_0 => {
      onChangeDate(date_0);
      const dateFrom = date_0[0]?.dateTime;
      const dateTo = date_0[1]?.dateTime;
      if (dateTo && dateFrom || !dateTo && !dateFrom) {
        setQueryParameters({
          date_from: dateFrom,
          date_to: dateTo
        });
      }
    };
    $[31] = onChangeDate;
    $[32] = setQueryParameters;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  const onFlatCalendarChange = t18;
  let t19;
  if ($[34] !== onChangeDate) {
    t19 = date_1 => {
      onChangeDate(date_1);
    };
    $[34] = onChangeDate;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  const onDatepickerChange = t19;
  let t20;
  if ($[36] !== date || $[37] !== setQueryParameters) {
    t20 = () => {
      const dateFrom_0 = date[0]?.dateTime;
      const dateTo_0 = date[1]?.dateTime;
      if (dateTo_0 && dateFrom_0 || !dateTo_0 && !dateFrom_0) {
        setQueryParameters({
          date_from: dateFrom_0,
          date_to: dateTo_0
        });
      }
    };
    $[36] = date;
    $[37] = setQueryParameters;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  const onCalendarAccept = t20;
  let t21;
  if ($[39] !== date || $[40] !== onCalendarAccept || $[41] !== onDatepickerChange || $[42] !== onFlatCalendarChange) {
    t21 = {
      calendarDate: date,
      onFlatCalendarChange,
      onDatepickerChange,
      onCalendarAccept
    };
    $[39] = date;
    $[40] = onCalendarAccept;
    $[41] = onDatepickerChange;
    $[42] = onFlatCalendarChange;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  return t21;
};